import { isServiceError } from './isServiceError';
import { isErrorBoundaryError } from './ErrorBoundaryError';
import { isObject } from './isServiceError';
const getContextForServiceError = error => {
  if (!isServiceError(error)) {
    return error;
  }
  const {
    message,
    error: {
      status,
      statusText,
      responseJSON
    },
    options,
    cause,
    stack
  } = error;
  const extra = {
    message,
    status,
    statusText,
    responseJSON,
    cause: getErrorContext(cause),
    stack
  };
  const href = isObject(options) && 'href' in options && options.href ? options.href.toString() : 'unknown';
  return {
    extra,
    fingerprint: ['ServiceError', message, status.toString(), href],
    tags: {
      errorType: 'ServiceError'
    }
  };
};
const getContextForErrorBoundaryError = error => {
  const {
    message,
    options: {
      errorInfo,
      boundaryName,
      cause
    },
    stack
  } = error;
  const extra = {
    message,
    errorInfo,
    boundaryName,
    cause: getErrorContext(cause),
    stack
  };
  return {
    extra,
    fingerprint: ['ErrorBoundaryError', boundaryName, message],
    tags: {
      errorType: 'ErrorBoundaryError',
      boundaryName
    }
  };
};
const getContextForGenericError = error => {
  const {
    message,
    stack,
    cause
  } = error;
  return {
    extra: {
      message,
      cause: getErrorContext(cause),
      stack
    },
    fingerprint: ['Error', message],
    tags: {
      errorType: error.constructor.name
    }
  };
};
const isError = error => error instanceof Error;
export function getErrorContext(error) {
  if (!error) {
    return null;
  } else if (isServiceError(error)) {
    return getContextForServiceError(error);
  } else if (isErrorBoundaryError(error)) {
    return getContextForErrorBoundaryError(error);
  } else if (isError(error)) {
    return getContextForGenericError(error);
  }

  // Fallback
  return {
    extra: {
      errorMessage: typeof (error === null || error === void 0 ? void 0 : error.toString) === 'function' ? error.toString() : error
    }
  };
}